const bookingStatusLabel = {
  MANUAL_PAYMENT: "Manual-Payment",
  APPROVED: "Approved",
  PENDING: "Pending",
  INCOMPLETE: "Incomplete",
  CANCELLED: "Cancelled",
  DECLINED: "Declined",
  PAYMENT_DECLINED: "Payment Declined",
  'PROCESSING-ACH-REFUND-ADJUSTED': "Processing-ACH-Refund-Adjusted",
  'PROCESSING-ACH-PAYMENT': "Processing-ACH-Payment",
  "Approved-Adjusted": "Approved-Adjusted"
};
const bookingSubscriptionStatusLabel = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  DECLINED: "DECLINED",
  NONE: "NONE"
};

export {
  bookingStatusLabel,
  bookingSubscriptionStatusLabel
}
